import { render, staticRenderFns } from "./_Social.vue?vue&type=template&id=5e5dbfb4&"
import script from "./_Social.vue?vue&type=script&lang=js&"
export * from "./_Social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports